export const addresses = {
  storeAddress:"0x6c11C6A8F1CE9EBe279f29d1466d77D9406B31d1",
  tokenAddress:"0x05C3Cb9d28Ff7675389300131849609d91519DF7"
}
